import SettingsContent from '../Wrapper';
import TeamsHome from './Index';
import TeamHint from './TeamHint';
import TeamsHeader from './TeamsHeader';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/teams'),
      component: SettingsContent,
      props: {
        headerTitle: 'TEAMS_SETTINGS.HEADER',
        headerButtonText: 'TEAMS_SETTINGS.NEW_TEAM',
        // No icon before the title on the new list design.
        icon: '',
        // "What is this?" hint popover next to the title.
        hintComponent: TeamHint,
        // Teams-list title styling (Figma).
        titleClass:
          'text-2xl font-bold leading-8 text-[#4B5563] dark:text-slate-100',
        // Hide the sidemenu toggle icon next to the title.
        showSidemenuIcon: false,
        // The list renders its own "Create new team" button (TeamsHeader),
        // so disable the shared header's built-in button.
        newButtonRoutes: [],
      },
      children: [
        {
          path: '',
          name: 'settings_teams',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'settings_teams_list',
          components: {
            default: TeamsHome,
            header: TeamsHeader,
          },
          roles: ['administrator'],
        },
      ],
    },
  ],
};
